import { ILinkViewModelConstructorParameter } from '#/DefaultViewExtensionInterfaces';
import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import ImageViewModel from '@/ViewModels/Controls/ImageViewModel';
import LinkViewModelBuilder from '@/Builder/LinkViewModelBuilder';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import OverlayViewModel from '@/ViewModels/Controls/OverlayViewModel';
import GlobalConfiguration from '@/Management/GlobalConfiguration';

export default class LinkViewModel extends ControlViewModel {

    public isExtern: boolean;

    public href: KnockoutObservable<string>;

    /**
     * Gibt an, ob der Link den Fokus hat
     */
    public hasFocus: KnockoutObservable<boolean>;

    /**
     * Gibt an, welcher der Links in der Untergruppe selektiert ist
     */
    public selectedChild: KnockoutObservable<LinkViewModel>;

    /**
     * Gibt den Wert an, falls es sich um ein Child handelt
     */
    public childValue: KnockoutObservable<any>;

    /**
     * Gibt an, ob es sich um einen Link in der ToolBar handelt
     */
    public isToolBarLink: KnockoutObservable<boolean>;

    /**
     * Definiert eine Untergruppe an Links
     */
    public childLinks: KnockoutObservableArray<LinkViewModel>;

    /**
     * Das ViewModel für das Label
     */
    public label: LabelViewModel;

    /**
     * Das ViewModel für das Icon
     */
    public image: ImageViewModel;

    public isPrimaryLink: KnockoutObservable<boolean>;

    public overlay: OverlayViewModel;

    /**
     * Der ARIA-Label-Text
     */
    public ariaLabel: string;

    public hotkey: any;

    public hotkeySuspendOnModal?: boolean;

    public constructor(protected params: ILinkViewModelConstructorParameter) {
        super(params);
        this.isExtern = this.paramOrDefault(params.isExtern, false);
        this.href = this.observableOrDefault(params.href, '');

        if(params.onClick)
            this.onClick = this.handlerOrDefault(params.onClick) as (openInNewWindow?: boolean, event?: JQuery.Event)=> void;

        if ((params.onClick || this.isExtern) && (params.isFocusable === null || params.isFocusable === undefined)) {
            this.isFocusable(true);
        }

        if (params.hotkey) {
            this.hotkeySuspendOnModal = params.hotkeySuspendOnModal || true;
            this.hotkey = {
                shortcut: params.hotkey,
                handler:  () => {
                    if (this.isEnabled() && this.isVisible()) {
                        this.onClick();
                    }
                },
                suspendOnModal: this.hotkeySuspendOnModal
            };
        }

        this.hasFocus = this.observableOrDefault(params.hasFocus, false);
        this.selectedChild = this.observableOrDefault(params.selectedChild as any, null);
        this.childValue = this.observableOrDefault(params.childValue, null);
        this.isToolBarLink = this.observableOrDefault(params.isToolBarLink, false);
        this.childLinks = this.observableOrDefault(params.childLinks as any, []) as  KnockoutObservableArray<LinkViewModel>;
        this.label = this.paramOrDefault(params.label, this.createLabelViewModel());
        this.image = this.paramOrDefault(params.image, this.createImageViewModel());
        this.isPrimaryLink = this.observableOrDefault(params.isPrimaryLink, false);
        this.overlay = this.paramOrDefault(params.overlay);
        this.ariaLabel = this.paramOrDefault(params.ariaLabel, '');
    }

    /**
     * Ein Handler, der aufgerufen wird, wenn der Link angeklickt wird
     */
    public onClick(openInNewWindow?: boolean, event?: JQuery.Event): void {

    }

    protected createLabelViewModel(): LabelViewModel {
        return null;
    }

    protected createImageViewModel(): ImageViewModel {
        return null;
    }

    /**
     * Erzeugt ein neues LinkViewModel für einen RevertButton
     * @param callback
     */
    public static createRevertViewModel(callback): any {
        return new LinkViewModelBuilder()
            .withImage()
            .withSource(GlobalConfiguration.inlineImages.RESET)
            .withWidth(16)
            .withHeight(16)
            .done()
            .withOnClick(callback)
            .withIsToolBarLink(true)
            .build();
    }
}

ComponentManager.setViewModel('LinkViewModel', LinkViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');